<template>
  <div
    v-if="offer"
    class="card"
    :class="{ top: offer && (!offer.discount || !offer.discount.percent) }"
  >
    <div v-if="isMonitoring" class="monitoring-banner" @click="toMonitoring">
      <div class="monitoring-banner__title heading-xs">
        Теперь у&nbsp;нас есть анализ цен
      </div>
      <div class="monitoring-banner__text body-m-regular-long">
        Собрали цены ведущих магазинов, чтобы вы&nbsp;знали рыночную стоимость
        и&nbsp;не&nbsp;переплачивали
      </div>
      <div class="monitoring-banner__icon">
        <UiIcon name="right" stroke="#212121" />
      </div>
      <div class="monitoring-banner__image" />
    </div>
    <div v-if="!isMobile">
      <template v-if="count === -1">
        <div class="popular-model__preloader first"></div>
      </template>
      <div v-else-if="count > 0" class="popular-model">
        <UiStickerMonitoring
          v-if="isMinPrice || isLessThenAvg"
          class="p-c-price__minimal"
          is-click
          :type="isMinPrice ? 'minimal' : 'percent-monitoring'"
          :text="isMinPrice ? 0 : offer.less_than_avg"
          @click-sticker="$emit('openMonitoringStickerModal', offer)"
        />
        <div class="model-exclusive-promo-wrapper" @click="copyPromo">
          <lazy-exclusive-promo
            :coupon="getCoupon(offer)"
            :copy="alreadyCopyPromo"
            @reset-copy="alreadyCopyPromo = false"
          >
            <div>
              <div class="price">
                <ui-currency class="currency price-m" :value="offer.price" />
                <ui-currency
                  v-if="offer.discount && offer.discount.price_before"
                  class="currency--old body-s-strikethrough"
                  :value="offer.discount.price_before"
                />
                <div
                  v-if="offer.discount && offer.discount.percent"
                  class="sticker-discount"
                >
                  <UiStickerMonitoring
                    type="percent"
                    :text="offer.discount.percent"
                  />
                </div>
              </div>
            </div>
          </lazy-exclusive-promo>
        </div>

        <div class="delivery">
          <ui-delivery-info-b :model="offer" />
        </div>
        <ui-ui-link
          icon-after="right"
          font-class="body-m-regular"
          size="medium"
          :font-weight="400"
          responsive-ico
          @click="openQuickView"
        >
          Описание от магазина
        </ui-ui-link>
        <ui-cpc-link
          v-if="!isPlaceOrder(offer)"
          id="slot1"
          data-slot="1"
          :position="1"
          block-type="popular"
          data-block="popular"
          :data-offer_id="offer.id"
          :data-url="objToBase64({ url: offer?.view_url })"
          class="shop-button"
          :offer="offer"
          :to="offer.click_url"
        >
          <ui-ui-button
            size="medium"
            font-class="body-l-regular"
            mode="div"
            :resize="true"
            icon-after="link-external"
          >
            В магазин
          </ui-ui-button>
        </ui-cpc-link>
        <div v-else class="shop-button">
          <ui-ui-button
            id="slot1"
            data-slot="1"
            :position="1"
            block-type="popular"
            data-block="popular"
            :data-offer_id="offer.id"
            :data-url="objToBase64({ url: offer?.view_url })"
            size="medium"
            :resize="true"
            font-class="body-m-regular"
            @click="openOrderModal(offer, 1)"
          >
            Сделать заказ
          </ui-ui-button>
        </div>
        <p class="advertising-marker hide l-popular_model">
          {{ advertising }}
        </p>
      </div>
      <template v-if="count === -1">
        <div class="popular-model__preloader"></div>
        <div class="popular-model__preloader"></div>
      </template>
      <div
        v-else-if="count > 0 && offersList?.length > 1"
        class="popular-model-wrapper"
      >
        <template v-for="(item, index) in offersList" :key="index">
          <div
            v-if="index !== 0 && index < 3"
            :key="String(index)"
            class="popular-model add-offer"
          >
            <div class="sub-offer-info">
              <div class="price price-m">
                <ui-currency :value="item.price" />
              </div>
            </div>
            <div class="promo-wrapper" @click="copyPromo(index)">
              <lazy-exclusive-promo
                :coupon="getCoupon(item)"
                :copy="OffersListArr[index]"
                @reset-copy="OffersListArr[index] = false"
              />
            </div>
            <div class="sub-shop-info">
              <div class="shop body-m-regular icons">
                <div>{{ getShopName(item) }}</div>
              </div>
              <shop-rating :shop="item" :is-popular="true" />
            </div>
            <div class="l-mtop">
              <ui-cpc-link
                v-if="!isPlaceOrder(item)"
                :id="`slot${index + 1}`"
                :position="index + 1"
                :data-slot="index + 1"
                block-type="popular"
                data-block="popular"
                :data-offer_id="item.id"
                :data-url="objToBase64({ url: item?.view_url })"
                :offer="item"
                :to="item.click_url"
                class="in-shop-button"
              >
                <ui-ui-button
                  size="medium"
                  type="neutral"
                  font-class="body-m-regular"
                  mode="div"
                  :resize="true"
                  icon-after="link-external"
                >
                  В магазин
                </ui-ui-button>
              </ui-cpc-link>
              <ui-ui-button
                v-else
                :id="`slot${index + 1}`"
                type="neutral"
                size="medium"
                :position="index + 1"
                :data-slot="index + 1"
                block-type="popular"
                data-block="popular"
                :data-url="objToBase64({ url: item?.view_url })"
                font-class="body-m-regular"
                :resize="true"
                @click="openOrderModal(item, index + 2)"
              >
                Сделать заказ
              </ui-ui-button>
            </div>
          </div>
        </template>
      </div>
      <ui-ui-button
        v-if="count > 3 || count === -1"
        class="more-offers"
        :loading="count === -1"
        :disabled="count === -1"
        type="neutral"
        :resize="true"
        @click="toMore"
      >
        Ещё {{ wordEnd(count - 3) }}
      </ui-ui-button>
    </div>
    <HowToBuy class="how-modal-button" type="model" :count="wordEnd(count)">
      <UiLink
        mode="button"
        font-class="body-l-regular"
        responsive-ico
        :font-weight="400"
        icon-after="help-circle"
      >
        Как купить товар
      </UiLink>
    </HowToBuy>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { ModelOfferItem } from '~/interfaces/api';
import numWord from '~/common/num-word.js';
import { useAnalyticsStore } from '~/stores/analytics';
import { useGlobalStore } from '~/stores/global';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import HowToBuy from '~/components/ui/HowToBuy.vue';
import UiLink from '~/components/ui/ui-link/ui-link.vue';
import { useModalsStore } from '~/stores/modals';
import { objToBase64 } from '~/utils/base64';

const { $ymAnyEvent } = useNuxtApp();

const ShopRating = defineAsyncComponent(
  () => import('~/components/ui/shop-rating/ShopRating.vue')
);
const props = defineProps({
  count: {
    type: Number,
    default: 0,
  },
  offers: {
    type: Object,
    default: () => {},
  },
  isMonitoring: {
    type: Boolean,
    default: false,
  },
});
const globalStore = useGlobalStore();
const mediaStore = useMediaQueryStore();
const modalsStore = useModalsStore();
const isXl = computed(() => mediaStore.isXl);
const isBot = computed(() => globalStore.isBot);
const isMobile = computed(
  () =>
    mediaStore.isMobile || mediaStore.isEs || mediaStore.isSm || mediaStore.isMd
);
const emit = defineEmits([
  'openQuickView',
  'to-route',
  'goTo',
  'openMonitoringStickerModal',
]);
const analyticsStore = useAnalyticsStore();
const offer = computed(() => {
  return props.offers?.list[0] || null;
});
const isMinPrice = computed(() => offer.value?.has_min_price);
const isLessThenAvg = computed(
  () => !isMinPrice.value && !!offer.value?.less_than_avg
);
const offerSite = computed(() => {
  if (!offer.value || !offer.value?.shop_info?.site) return '';
  return offer.value?.shop_info?.site;
});
const advertising = `Реклама, ${offerSite.value.split('//')[1] || ''}`;

const offersList = computed(() => {
  if (!props.offers || !props.offers?.list) return [];
  return props.offers.list;
});
const isPlaceOrder = (offer: ModelOfferItem) => {
  if (offer) return !!offer?.cpo;
  return false;
};

const openOrderModal = (offer: ModelOfferItem, position: number) => {
  modalsStore.setData({
    name: 'order',
    data: {
      offer,
      position,
      blockType: 'popular',
    },
  });
};
// Закомментарил 21.03.2004, потому что, мне кажется, могут вернуть:
// в топах появляются предложения, которые выглядят одинаково.
// const showOffersList = computed(() => {
//   if (!offer.value) return [];
//   return offersList.value.filter(
//     (item: ModelOfferItem) =>
//       item.shop_info.name !== offer.value?.shop_info?.name ||
//       item.price !== offer.value?.price
//   );
// });

function openQuickView() {
  emit('openQuickView');
  $ymAnyEvent('reachGoal', 'click_na_opisanie_ot_magazina');
}

function toMore() {
  emit('to-route', 'offers');
}

function toMonitoring() {
  const monitoring = document.getElementById('monitoring');
  if (monitoring) emit('goTo', monitoring, false, 100);
}

function getShopName(offer: ModelOfferItem) {
  // Костыль. Нужен до тех пор, пока он не будет переписан на новую сетку.
  // Текущая сетка не имеет нужных брекпоинтов для переключения
  if (isXl.value) {
    return offer?.shop_info?.name && offer.shop_info.merchant_rating_grades
      ? offer?.shop_info?.name?.slice(0, 7) + '...'
      : offer?.shop_info?.name
      ? offer?.shop_info?.name
      : '';
  }
  return offer?.shop_info?.name || '';
}

function getCoupon(item: ModelOfferItem) {
  return item.shop_info?.coupon || {};
}

function wordEnd(val: number) {
  return numWord(val, ['', 'предложение', 'предложения', 'предложений'], true);
}

const alreadyCopyPromo = ref(false);
const OffersListArr = ref([false, false, false]);
const copyPromo = (value: number) => {
  if (typeof value === 'number') {
    OffersListArr.value[value] = true;
  } else {
    alreadyCopyPromo.value = true;
  }
};

onMounted(() => {
  nextTick(() => {
    if (!import.meta.env.SSR) {
      const slot1 = document.getElementById('slot1');
      const slot2 = document.getElementById('slot2');
      const slot3 = document.getElementById('slot3');
      if (slot1) analyticsStore.observeView(slot1);
      if (slot2) analyticsStore.observeView(slot2);
      if (slot3) analyticsStore.observeView(slot3);
    }
  });
});

onBeforeUnmount(() => {
  const slot1 = document.getElementById('slot1');
  const slot2 = document.getElementById('slot2');
  const slot3 = document.getElementById('slot3');
  if (slot1) analyticsStore.unobserveView(slot1);
  if (slot2) analyticsStore.unobserveView(slot2);
  if (slot3) analyticsStore.unobserveView(slot3);
});
</script>
<style scoped lang="scss" src="./PopularModelScss.scss" />
